// Shared permission groups (UI labels -> backend permission keys). Mirrors the
// backend PERMISSIONS catalogue used across Users & Access and Owner Override.
export const PERM_GROUPS = [
  { title: 'Dashboard', perms: [['dashboard', 'View']] },
  { title: 'Billing / Sales', perms: [['billing_view', 'View'], ['billing_create', 'Create Sale'], ['billing_edit', 'Edit / Price'], ['billing_cancel', 'Cancel / Void']] },
  { title: 'Returns / Exchange', perms: [['returns', 'Returns'], ['exchanges', 'Exchanges']] },
  { title: 'Stock', perms: [['stock_view', 'View'], ['stock_add', 'Add'], ['stock_edit', 'Edit'], ['stock_adjust', 'Adjust']] },
  { title: 'Transfers', perms: [['transfer_view', 'View'], ['transfer_create', 'Create']] },
  { title: 'Customers', perms: [['customers_view', 'View'], ['customers_create', 'Create / Edit']] },
  { title: 'Purchases', perms: [['purchases_view', 'View'], ['purchases_create', 'Create']] },
  { title: 'Suppliers', perms: [['suppliers_view', 'View'], ['suppliers_create', 'Create']] },
  { title: 'Expenses', perms: [['expenses_view', 'View'], ['expenses_create', 'Create']] },
  { title: 'Reports', perms: [['reports_view', 'Reports'], ['profit_view', 'Profit']] },
  { title: 'Settings', perms: [['settings_view', 'View'], ['settings_edit', 'Edit']] },
  { title: 'Administration', perms: [['users_manage', 'User Management'], ['integration_manage', 'Integrations']] },
  { title: 'Sensitive', perms: [['view_cost', 'See cost price & stock value']] },
];
export const ALL_PERM_KEYS = PERM_GROUPS.flatMap((g) => g.perms.map((p) => p[0]));
